// extracted by mini-css-extract-plugin
module.exports = {"verifyButton":"VerifySignature_verifyButton__36nV_","verifySuccess":"VerifySignature_verifySuccess__3vvTH","verifyFailure":"VerifySignature_verifyFailure__fJwx9"};